export default __webpack_public_path__ + "locales/sr-Latn-RS/People.json?hash=33fc8bbdc1d539caa580380d5b213d4d";